import { useContext } from 'react';
import { NotificationFunctionContext } from '../components/notifications/notificationProvider';
import { HttpError } from '../api/generated/studiested-generated-api';

/**
 * IMPORTANT: Cannot be used outside NotificationFunctionContext hierarchy
 * It is though an edge case to be in such a situation.
 * */
const useAddErrorNotificationCallback = <T,>(
  callback?: Function,
): ((error: T) => void) => {
  const { addErrorNotification } = useContext(NotificationFunctionContext);

  return (error: T) => {
    let errorMsg: string;

    if (error instanceof HttpError) {
      errorMsg = error.body;
    } else if (error instanceof Error) {
      errorMsg = error.message;
    } else {
      errorMsg = error?.toString() || 'Unknown error';
    }

    addErrorNotification(errorMsg);

    if (callback) callback();
  };
};

export default useAddErrorNotificationCallback;
